import React from 'react'
import '../styles/LoadingIcon.css'

const LoadingIcon = () => {
  return (
    <div className="lds-ring">
      <div />
      <div />
      <div />
      <div />
    </div>
  )
}

export default LoadingIcon
